import { NgModule,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvisDePubRoutingModule } from './avis-de-pub-routing.module';
import { HomeAvisDePubComponent } from './home-avis-de-pub/home-avis-de-pub.component';
import { ListerAvisDePubComponent } from './lister-avis-de-pub/lister-avis-de-pub.component';
import { SharedModule } from '../shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { CreerModule } from './creer/creer.module';
import { TranslateModule } from '@ngx-translate/core';
import { VisualiserAvisDePubComponent } from './visualiser-avis-de-pub/visualiser-avis-de-pub.component';
import { SyntheseComponent } from './visualiser-avis-de-pub/synthese/synthese.component';
import { HistoriqueComponent } from './visualiser-avis-de-pub/historique/historique.component';
import { PopupSupprimerComponent } from './visualiser-avis-de-pub/popup-supprimer/popup-supprimer.component';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopupEnregistrerComponent } from './visualiser-avis-de-pub/popup-enregistrer/popup-enregistrer.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PopupDupliquerComponent } from './visualiser-avis-de-pub/popup-dupliquer/popup-dupliquer.component';
import { InterceptorService } from '../../authentication/interceptor.service';
import { PopupChangeComponent } from './visualiser-avis-de-pub/popup-change/popup-change.component';
import { ImportComponent } from './import/import.component';
import { ImportAvisConfirmationModalComponent } from './import-avis-confirmation-modal/import-avis-confirmation-modal.component';

@NgModule({
	declarations: [
		ListerAvisDePubComponent,
		HomeAvisDePubComponent,
		VisualiserAvisDePubComponent,
		SyntheseComponent,
		HistoriqueComponent,
		PopupDupliquerComponent,
		PopupChangeComponent,
		PopupSupprimerComponent,
		PopupEnregistrerComponent,
		ImportComponent,
		ImportAvisConfirmationModalComponent
	],
	imports: [
		MatProgressSpinnerModule,
		CommonModule,
		AvisDePubRoutingModule,
		SharedModule,
		CreerModule,
		MatTableModule,
		TranslateModule,
		MatIconModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule
	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true }
	],
	schemas: [
	  CUSTOM_ELEMENTS_SCHEMA
	]
})
export class AvisDePubModule { }
